import React from "react"
import { MdSettingsEthernet } from "react-icons/md"
import { Badge } from "gatsby-interface"

export function Integration({ children, large, className }) {
  return (
    <div
      css={theme => ({
        padding: large
          ? `${theme.space[8]} ${theme.space[9]} ${theme.space[9]}`
          : `${theme.space[5]} ${theme.space[9]}`,
      })}
      className={className}
    >
      {children}
    </div>
  )
}

const rowCss = {
  display: "flex",
  flexDirection: "row",
  flex: 1,
}

Integration.Row = function({ children }) {
  return <div css={rowCss}>{children}</div>
}

const vendorImageCss = theme => ({
  height: `12px`,
  width: `auto`,
  margin: 0,
  display: "flex",
  alignSelf: "center",
  [theme.mediaQueries.tablet]: {
    height: `24px`,
  },
})

Integration.Vendor = function({ image, name }) {
  return <img src={image} alt={name} css={vendorImageCss} />
}

const statusCss = theme => ({
  marginLeft: theme.space[5],
  justifyContent: "center",
  display: "flex",
})

Integration.Status = function({ connected, ...props }) {
  return (
    connected && (
      <Badge
        Icon={MdSettingsEthernet}
        css={statusCss}
        {...props}
        tone="SUCCESS"
      >
        Connected
      </Badge>
    )
  )
}

const actionsCss = {
  marginLeft: "auto",
  display: "flex",
  alignSelf: "center",
}

Integration.Actions = function({ children }) {
  return <div css={actionsCss}>{children}</div>
}

const detailsCss = theme => ({
  marginBottom: 0,
  marginTop: theme.space[5],
})

Integration.Details = function({ children, ...props }) {
  return (
    <dl css={detailsCss} {...props}>
      {children}
    </dl>
  )
}

const detailCss = theme => ({
  display: `grid`,

  fontSize: theme.fontSizes[1],
  gridTemplateColumns: `1fr 1fr`,
  marginTop: theme.space[4],
  "&:first-of-type": {
    marginTop: `0`,
  },

  [theme.mediaQueries.tablet]: {
    gridTemplateColumns: `0.35fr 1fr`,
  },
})

Integration.Detail = function({ children, ...props }) {
  return (
    <div {...props} css={detailCss}>
      {children}
    </div>
  )
}

const labelCss = theme => ({
  fontFamily: theme.fonts.system,
  fontWeight: 100,
  lineHeight: theme.lineHeights.heading,
  textTransform: `capitalize`,
  display: "flex",
  alignSelf: "center",
  marginBottom: 0,
})

Integration.Label = function({ children }) {
  return <dd css={labelCss}>{children}</dd>
}

const valueCss = theme => ({
  marginTop: 0,
  marginBottom: 0,
  color: theme.colors.grey[90],
})

Integration.Value = function({ children }) {
  return <dd css={valueCss}>{children}</dd>
}
